import { useState } from "react";
import Image from "next/image";
import RegistrationButton from "@/components/common/buttons/registrationbutton";
import RegistrationForm from "@/components/common/registrationform";
import logoimg from "../../public/assets/images/easycampuslogo.jpg";
import campusimg from "../../public/assets/images/campus.png";
import corporateimg from "../../public/assets/images/corporate.png";
import studentimg from "../../public/assets/images/student.png";

const RegistrationPage = () => {
  const [currentForm, setCurrentForm] = useState(null);
  const [activeButton, setActiveButton] = useState(null);
  const [isHeadingVisible, setHeadingVisible] = useState(true);

  const handleButtonClick = (formType) => {
    setCurrentForm(formType);
    setActiveButton(formType);
    setHeadingVisible(false);
  };

  return (
    <>
      <div className={`loginContainer`}>
        <div className={`overlay`}></div>
        <div className="flex justify-center items-center h-screen ">
          <div className={`${currentForm === "student" ? "w-[30rem]" : "w-96"} p-5 shadow-lg bg-white rounded-md absolute flex flex-col items-center`}>
            <div className="mb-2 w-[50%]">
              <Image src={logoimg} alt="logoimg" />
            </div>
            {isHeadingVisible && (
              <h2 className="registerhead font-semibold mb-2">
                Registering As
              </h2>
            )}
            <div className="flex space-x-4">
              <RegistrationButton
                image={campusimg}
                label="Campus"
                onClick={() => handleButtonClick("campus")}
                active={activeButton === "campus"}
              />
              <RegistrationButton
                image={corporateimg}
                label="Corporate"
                onClick={() => handleButtonClick("corporate")}
                active={activeButton === "corporate"}
              />
              <RegistrationButton
                image={studentimg}
                label="Student"
                onClick={() => handleButtonClick("student")}
                active={activeButton === "student"}
              />
            </div>
            {currentForm && (
              <div className="w-full">
                <h2 className="text-xl pb-2 block text-center font-semibold text-[#012970]">
                  Register as{" "}
                  {currentForm.charAt(0).toUpperCase() + currentForm.slice(1)}
                </h2>
                <RegistrationForm formType={currentForm} />
              </div>
            )}
          </div>
        </div>
      </div>
     
    </>
  );
};
RegistrationPage.displayName = "RegistrationPage";
export default RegistrationPage;
